import { render, staticRenderFns } from "./MessageLoadingSkeleton.vue?vue&type=template&id=7fb0999a&scoped=true"
import script from "./MessageLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./MessageLoadingSkeleton.vue?vue&type=script&lang=js"
import style0 from "./MessageLoadingSkeleton.vue?vue&type=style&index=0&id=7fb0999a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb0999a",
  null
  
)

export default component.exports